import React from 'react'
import { Route, Routes } from "react-router-dom"
import ShipmentLoadingByVehicleList from "screens/App/CRM/ShipmentLoading/ShipmentLoadingByVehicleList"
import ShipmentLoadingCreateScreen from "screens/App/CRM/ShipmentLoading/ShipmentLoadingCreateScreen"
import ShipmentLoadingDetailScreen from "screens/App/CRM/ShipmentLoading/ShipmentLoadingDetailScreen"
import ShipmentLoadingEditScreen from "screens/App/CRM/ShipmentLoading/ShipmentLoadingEditScreen"
import ShipmentLoadingListScreen from "screens/App/CRM/ShipmentLoading/ShipmentLoadingListScreen"
import NotFoundScreen from "screens/NotFoundScreen"


const ShipmentLoadingRouter = () => {
    return (
        <Routes>
            <Route path="create" element={<ShipmentLoadingCreateScreen />} />

            <Route path="list" element={<ShipmentLoadingListScreen />} />
            <Route path="loading-by-vehicles" element={<ShipmentLoadingByVehicleList />} />

            <Route path=":id/detail" element={<ShipmentLoadingDetailScreen />} />

            <Route path=":id/edit" element={<ShipmentLoadingEditScreen />} />

            <Route path="*" element={<NotFoundScreen />} />

        </Routes>
    )
}

export default ShipmentLoadingRouter